import { CellphoneDockIcon } from './CellphoneDockIcon';

/**
 * author: Google
 * id 4FBBF196-CF97-436B-A3E6-A08D695E6986
 * name cellphone-dock
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-dock.svg
 * tags
 * - Cellphone / Phone 
 * - Device / Tech 
 */
export const SmartphoneDockIcon = CellphoneDockIcon;
export default SmartphoneDockIcon